import useJobForm from '@orientaction/components/Form/CreateEditAdmin/Job/useJobForm';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import DetailJobComponent from './DetailJobComponent';

const DetailJob = () => {
  const { job, loading, loadData } = useJobForm();
  const [candidates, setCandidates] = useState();
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    const func = async () => {
      await loadData(id);
      window.scrollTo(0, 0);
    };
    func();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <DetailJobComponent isPreview={false} job={job} candidates={job.candidaturesCount} />;
};

export default DetailJob;
